// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   Grid,
//   Typography,
//   CircularProgress,
//   Input,
//   Tooltip,
//   IconButton,
//   FormHelperText,
// } from '@mui/material';
// import { useNavigate, useParams, Link } from 'react-router-dom';
// import { LeadFormActions } from '../../Services/_actions/index.js';
// import HomeIcon from '@mui/icons-material/Home';
// import { useRecoilState } from 'recoil';
// import DynamicBreadcrumbs from '../Shared/Breadcrumb/index.tsx';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import { campaignLeadManagementAtom } from '../../Services/_states/index.js';
// import { BackButton } from '../Shared/BackButton/index.jsx';
// import {
//   BLOCKED_EXTENSIONS,
//   WHATSAPP_ALLOWED_MIME,
//   WHATSAPP_LIMITS,
// } from '../Whatsapp/Template/template.constant.js';
// import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
// import DownloadIcon from '@mui/icons-material/Download';

// const ImportLeads: React.FC = () => {
//   const { campaignId, leadFormId } = useParams<{ campaignId: string; leadFormId: string }>();
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);
//   const { showSnackBar } = useSnackBar();
//   const [selectedFile, setSelectedFile] = useState<File | null>(null);
//   const navigate = useNavigate();
//   const actions = LeadFormActions();
//   const [campaignLeadManagementData, setCampaignLeadManagementData] = useRecoilState(
//     campaignLeadManagementAtom
//   );
//   const [errorCells, setErrorCells] = useState<any>(null);
//   // const leadFormId = campaignLeadManagementData?.selectedForm?.leads_form_id;
//   // const breadcrumbsData = [
//   //   {
//   //     label: (
//   //       <IconButton color="primary">
//   //         <HomeIcon />
//   //       </IconButton>
//   //     ),
//   //     onClick: () => navigate(`/`),
//   //   },
//   //   { label: 'Dashboards', onClick: () => navigate('/r/records/campaigns') },
//   //   { label: 'Dashboards Master', onClick: () => navigate(`/r/records/${campaignId}/form`) },
//   //   { label: 'Import Leads' },
//   // ];

//   const inferDocType = (mime: string): 'image' | 'video' | 'audio' | 'file' | null => {
//     if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
//     if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
//     if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
//     if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
//     return null;
//   };
//   const bytesToMB = (bytes: number) => (bytes / (1024 * 1024)).toFixed(2);

//   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];
//     if (!file) return;
//     const fileName = file?.name?.toLowerCase();
//     const ext = fileName.split('.').pop();
//     if (BLOCKED_EXTENSIONS.has(ext)) {
//       showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
//       event.target.value = '';
//       return;
//     }
//     const typeGroup = inferDocType(file.type);
//     if (!typeGroup) {
//       showSnackBar(`Unsupported file type (${file.type || ext}).`, 'error');
//       event.target.value = '';
//       return;
//     }

//     const limit = WHATSAPP_LIMITS[typeGroup];
//     if (file.size > limit) {
//       showSnackBar(
//         `File too large for ${typeGroup}. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file?.size)} MB.`,
//         'error'
//       );
//       event.target.value = '';
//       return;
//     }
//     if (file && file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
//       setSelectedFile(file);
//       setError(null);
//     } else {
//       setError('Please upload a valid .xlsx file.');
//     }
//   };

//   const handleFileUpload = async () => {
//     if (!selectedFile) {
//       setError('Please select a file to upload.');
//       return;
//     }

//     if (!leadFormId) {
//       setError('Lead Form ID is missing in the URL.');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', selectedFile);

//     setLoading(true);
//     try {
//       const response = await actions.uploadLeadsFile(leadFormId, formData);
//       const errorRes = response?.data?.data?.general_error?.error_cells ?? null;
//       if (errorRes) {
//         setErrorCells(errorRes);
//       }
//       if (response?.status === 200) {
//         navigate(`/r/records/v1`);
//       }
//       // else if(errorCells){
//       //   const errorFormData = new FormData();
//       //   errorFormData.append('file', selectedFile);
//       //   errorFormData.append("error_cells", JSON.stringify(errorCells))
//       //   actions.downloadHighlightedErrorFile(errorFormData)
//       // }
//       else {
//         setError(
//           response?.data?.data?.general_error?.message ??
//             'Failed to upload Records. Please try again.'
//         );
//       }
//     } catch (error) {
//       setError('Error during file upload. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownloadSample = () => {
//     if (!leadFormId) {
//       setError('Lead Form ID is missing. Cannot download sample file.');
//       return;
//     }
//     actions.downloadSampleLeadUploadFile(leadFormId);
//   };

//   const handleDownloadErrorFile = async () => {
//     if (!selectedFile || !errorCells) {
//       showSnackBar('No error data available to download.', 'error');
//       return;
//     }
//     try {
//       const errorFormData = new FormData();
//       errorFormData.append('file', selectedFile);
//       errorFormData.append('error_cells', JSON.stringify(errorCells));

//       await actions.downloadHighlightedErrorFile(errorFormData);
//       showSnackBar('Error file downloaded successfully!', 'success');
//     } catch (error) {
//       showSnackBar('Failed to download error file. Please try again.', 'error');
//     }
//   };

//   return (
//     <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', padding: '5px' }}>
//       {/* <DynamicBreadcrumbs
//         items={breadcrumbsData}
//         onBreadcrumbClick={(e, item) => item?.onClick?.()}
//       /> */}

//       <Grid container spacing={2} justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
//         <Grid item>
//           <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//             Import Records
//           </Typography>
//         </Grid>
//         <Grid item>
//           <BackButton onClick={() => navigate(-1)} />
//         </Grid>
//       </Grid>

//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//         {/* Sample File Download */}
//         <Button
//           variant="outlined"
//           color="secondary"
//           onClick={handleDownloadSample}
//           sx={{ width: 'fit-content', alignSelf: 'flex-start' }}
//         >
//           Download Sample File
//         </Button>

//         {/* Upload Section */}
//         {loading ? (
//           <CircularProgress sx={{ mt: 2 }} />
//         ) : (
//           <Box
//             sx={{
//               border: '2px dashed #1976d2',
//               padding: 3,
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               cursor: 'pointer',
//               borderRadius: 1,
//               transition: 'background-color 0.3s ease',
//               '&:hover': { backgroundColor: '#e3f2fd' },
//               flexDirection: 'column',
//               textAlign: 'center',
//             }}
//             onClick={() => document.getElementById('file-upload')?.click()}
//           >
//             <CloudUploadIcon sx={{ fontSize: 50, color: '#1976d2', marginBottom: 2 }} />
//             {/* <Input
//               type="file"
//               accept=".xlsx"
//               onChange={handleFileChange}
//               sx={{ display: 'none' }}
//               id="file-upload"
//             /> */}
//             <input
//               type="file"
//               id="file-upload"
//               accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//               onChange={handleFileChange}
//               style={{ display: 'none' }}
//             />
//             <Typography variant="body2" color="textSecondary">
//               Drag & Drop or Click to Upload
//               <br />
//               <span style={{ fontSize: '0.9rem', color: '#616161' }}>Supports XLSX Only</span>
//             </Typography>
//             <FormHelperText sx={{ mt: 1 }}>Allowed: xlsx</FormHelperText>
//           </Box>
//         )}

//         {/* Selected File Info */}
//         {selectedFile && (
//           <Typography variant="body2" sx={{ marginTop: 1 }}>
//             Selected file: {selectedFile.name}
//           </Typography>
//         )}

//         {/* Error Message */}
//         {/* {error && (
//           <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>
//             {error}
//           </Typography>
//         )} */}

//         {error && (
//           <Box
//             sx={{
//               marginTop: 1,
//               padding: 2,
//               backgroundColor: '#ffebee',
//               borderRadius: 1,
//               border: '1px solid #ef5350',
//             }}
//           >
//             <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>
//               {error}
//             </Typography>
//             {error && (
//               <Button
//                 variant="contained"
//                 color="error"
//                 size="small"
//                 startIcon={<DownloadIcon />}
//                 onClick={handleDownloadErrorFile}
//                 sx={{
//                   textTransform: 'none',
//                   fontWeight: 'normal',
//                   mt: 1,
//                 }}
//               >
//                 Download Error File
//               </Button>
//             )}
//           </Box>
//         )}

//         {/* Upload Button */}
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={handleFileUpload}
//           disabled={loading || !selectedFile}
//           sx={{ textTransform: 'none', fontWeight: 'normal' }}
//         >
//           {loading ? 'Uploading...' : 'Upload Records'}
//         </Button>

//         {/* Loading Spinner */}
//       </Box>
//     </Box>
//   );
// };

// export default ImportLeads;


import React, { useState, useEffect } from 'react';
import readXlsxFile from 'read-excel-file';
import {
  Box, Button, Grid, Typography, CircularProgress, FormHelperText,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Stepper, Step, StepLabel, TextField, Select, MenuItem,
  FormControl, InputLabel, Chip, Divider, Paper, IconButton,
  Tooltip, Alert, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, LinearProgress,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { LeadFormActions } from '../../Services/_actions/index.js';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CodeIcon from '@mui/icons-material/Code';
import PublicIcon from '@mui/icons-material/Public';
import TableChartIcon from '@mui/icons-material/TableChart';
import CampaignIcon from '@mui/icons-material/Campaign';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useRecoilState } from 'recoil';
import { campaignLeadManagementAtom } from '../../Services/_states/index.js';
import { BackButton } from '../Shared/BackButton/index.jsx';
import {
  BLOCKED_EXTENSIONS, WHATSAPP_ALLOWED_MIME, WHATSAPP_LIMITS,
} from '../Whatsapp/Template/template.constant.js';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import { staticLeadTableColumns } from '../Leads/DynamicFormFields/helper.ts';

// ─── Types ────────────────────────────────────────────────────────────────────

type ImportSource = 'excel' | 'website' | 'social_media' | 'api';

interface WebFormField {
  key_name: string;
  alias_name: string;
  key_type: string;
  is_required?: boolean;
  order_id: number;
  item_id: number;
}

interface FieldMapping {
  sourceField: string;
  targetField: string;
  targetAlias: string;
  sampleValue?: string;
  isRequired?: boolean;
}

interface TrackingFields {
  sourceName: string;
  sourceCampaignName: string;
  sourceCampaignId: string;
  sourceAdName: string;
  sourceAdId: string;
}

interface WebsiteConfig { url: string; formSelector: string; apiKey: string; }
interface SocialConfig {
  platform: 'facebook' | 'instagram' | 'linkedin' | 'twitter' | '';
  accessToken: string; adAccountId: string; formId: string;
}
interface ApiConfig {
  endpointUrl: string; method: 'GET' | 'POST';
  authType: 'none' | 'bearer' | 'api_key' | 'basic';
  authValue: string; requestBody: string; responseMapping: string;
}

// ─── Utilities ────────────────────────────────────────────────────────────────

/** Read webForm fields from localStorage under "leadWebFormData" key */
const getWebFormFields = (): WebFormField[] => {
  try {
    const raw = localStorage.getItem('leadWebFormData');
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    const items =
      parsed?.webForm?.leads_form_items ??
      parsed?.leads_form_items ??
      {};
    return Object.values(items) as WebFormField[];
  } catch {
    return [];
  }
};


/** Flatten nested object to dot-notation keys, max depth 3 */
const flattenObject = (
  obj: Record<string, any>,
  prefix = '',
  depth = 0,
): Record<string, string> => {
  if (depth > 3) return {};
  const result: Record<string, string> = {};
  for (const [k, v] of Object.entries(obj ?? {})) {
    const key = prefix ? `${prefix}.${k}` : k;
    if (v !== null && typeof v === 'object' && !Array.isArray(v)) {
      Object.assign(result, flattenObject(v, key, depth + 1));
    } else {
      result[key] = Array.isArray(v) ? JSON.stringify(v) : String(v ?? '');
    }
  }
  return result;
};

/** Fuzzy match a source field name to a webForm field */
const autoMatch = (sourceField: string, fields: WebFormField[]): WebFormField | null => {
  const n = (s: string) => s.toLowerCase().replace(/[_\s\-\.]/g, '');
  const src = n(sourceField);
  return (
    fields.find(f => n(f.key_name) === src) ||
    fields.find(f => n(f.alias_name) === src) ||
    fields.find(f => src.includes(n(f.alias_name)) || n(f.alias_name).includes(src)) ||
    null
  );
};

const SOURCE_META: Record<ImportSource, { label: string; icon: React.ReactNode; color: string; description: string }> = {
  excel: { label: 'Excel / CSV', icon: <TableChartIcon />, color: '#217346', description: 'Upload .xlsx — columns auto-detected' },
  website: { label: 'Website Form', icon: <PublicIcon />, color: '#1565c0', description: 'Paste sample payload to detect fields' },
  social_media: { label: 'Social Media', icon: <CampaignIcon />, color: '#7b1fa2', description: 'Facebook, Instagram, LinkedIn Ads' },
  api: { label: 'API / Webhook', icon: <CodeIcon />, color: '#e65100', description: 'Any external API — paste sample response' },
};

const SOCIAL_PLATFORMS = [
  { value: 'facebook', label: 'Facebook Ads' },
  { value: 'instagram', label: 'Instagram Ads' },
  { value: 'linkedin', label: 'LinkedIn Lead Gen' },
  { value: 'twitter', label: 'Twitter / X Ads' },
];

const STEPS = ['Choose Source', 'Configure & Preview', 'Map Fields', 'Review & Import'];

// ─── Component ────────────────────────────────────────────────────────────────

const ImportLeads: React.FC = () => {
  // const { leadFormId } = useParams<{ campaignId: string; leadFormId: string }>();
  const navigate = useNavigate();
  const { showSnackBar } = useSnackBar();
  const actions = LeadFormActions();
 const { campaignId, leadFormId } = useParams<{ campaignId: string; leadFormId: string }>();
const [campaignLeadManagementData] = useRecoilState(campaignLeadManagementAtom);

const [webFormFields, setWebFormFields] = useState<WebFormField[]>([]);
const [fieldsLoading, setFieldsLoading] = useState(false);

  useEffect(() => {
  const loadFormFields = async () => {

    // ── Helper: merge leads_form_items + all static columns ─────────────
    // Static columns (phone_number, created_at, Comment, Audio Summary, AI Chat)
    // are NOT in leads_form_items but must appear in the mapping table
    const buildAllFields = (items: Record<string, any>): WebFormField[] => {
      const dynamicFields = Object.values(items) as WebFormField[];
      const dynamicKeys = new Set(dynamicFields.map(f => f.key_name));

      // Build static fields from helper — keep same order as LeadList columns
      const staticFields: WebFormField[] = Object.values(staticLeadTableColumns)
        .filter(col => !dynamicKeys.has(col.key_name)) // skip if already in form
        .map((col, i) => ({
          key_name: col.key_name,
          alias_name: col.alias_name,
          key_type: col.key_type,
          is_required: false,
          order_id: -(Object.values(staticLeadTableColumns).length - i), // prepend before dynamic
          item_id: -(i + 1),
        }));

      // Static first (phone_number, created_at, etc.) then dynamic form fields
      return [...staticFields, ...dynamicFields];
    };

    // ── 1. Recoil — works when navigating from LeadList same session ────
    const recoilItems = campaignLeadManagementData?.selectedForm?.leads_form_items;
    const recoilFormIdNum = Number(campaignLeadManagementData?.selectedForm?.leads_form_id);
    const urlFormIdNum = Number(leadFormId);

    console.log('[ImportLeads] Recoil formId:', recoilFormIdNum, '| URL formId:', urlFormIdNum);
    console.log('[ImportLeads] Recoil items count:', Object.keys(recoilItems ?? {}).length);

    if (
      recoilItems &&
      Object.keys(recoilItems).length > 0 &&
      !isNaN(recoilFormIdNum) &&
      !isNaN(urlFormIdNum) &&
      recoilFormIdNum === urlFormIdNum
    ) {
      console.log('[ImportLeads] ✅ Using Recoil data');
      setWebFormFields(buildAllFields(recoilItems));
      return;
    }

    // ── 2. API fetch via getFormsByCampaignId — works on refresh / direct URL ──
    if (!campaignId) {
      console.warn('[ImportLeads] No campaignId — falling back to localStorage');
      setWebFormFields(getWebFormFields());
      return;
    }

    try {
      setFieldsLoading(true);
      const res = await actions.getFormsByCampaignId(campaignId);

      console.log('[ImportLeads] API response:', res?.data);

      const forms: any[] = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.data)
          ? res.data.data
          : Array.isArray(res?.data?.forms)
            ? res.data.forms
            : [];

      console.log('[ImportLeads] Forms found:', forms.length, '| Looking for leadFormId:', leadFormId);

      const matchedForm = forms.find(
        f => Number(f.leads_form_id) === Number(leadFormId)
      );

      console.log('[ImportLeads] Matched form items count:', Object.keys(matchedForm?.leads_form_items ?? {}).length);

      const items = matchedForm?.leads_form_items ?? {};

      if (Object.keys(items).length > 0) {
        console.log('[ImportLeads] ✅ Using API data');
        setWebFormFields(buildAllFields(items));
        return;
      }

      console.warn('[ImportLeads] API returned no items — falling back to localStorage');
    } catch (e) {
      console.warn('[ImportLeads] API call failed — falling back to localStorage', e);
    } finally {
      setFieldsLoading(false);
    }

    // ── 3. localStorage — last resort (partial, no static columns) ──────
    const localFields = getWebFormFields();
    console.log('[ImportLeads] localStorage fields count:', localFields.length);
    // Still inject static columns even for localStorage fallback
    const localItems = localFields.reduce((acc, f, i) => {
      acc[String(i)] = f;
      return acc;
    }, {} as Record<string, any>);
    setWebFormFields(buildAllFields(localItems));
  };

  if (campaignId || leadFormId) {
    loadFormFields();
  }
}, [campaignId, leadFormId]);

  // ── Main page state ───────────────────────────────────────────────────────
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [errorCells, setErrorCells] = useState<any>(null);

  // ── Modal state ───────────────────────────────────────────────────────────
  const [modalOpen, setModalOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedSource, setSelectedSource] = useState<ImportSource | null>(null);

  // Detected source fields + sample rows
  const [detectedFields, setDetectedFields] = useState<string[]>([]);
  const [sampleRows, setSampleRows] = useState<Record<string, string>[]>([]);
  const [parseError, setParseError] = useState<string | null>(null);
  const [isParsing, setIsParsing] = useState(false);

  // Field mappings
  const [fieldMappings, setFieldMappings] = useState<FieldMapping[]>([]);

  // Tracking
  const [tracking, setTracking] = useState<TrackingFields>({
    sourceName: '', sourceCampaignName: '', sourceCampaignId: '',
    sourceAdName: '', sourceAdId: '',
  });

  // Source configs
  const [websiteConfig, setWebsiteConfig] = useState<WebsiteConfig>({ url: '', formSelector: '', apiKey: '' });
  const [socialConfig, setSocialConfig] = useState<SocialConfig>({ platform: '', accessToken: '', adAccountId: '', formId: '' });
  const [apiConfig, setApiConfig] = useState<ApiConfig>({ endpointUrl: '', method: 'GET', authType: 'none', authValue: '', requestBody: '', responseMapping: '' });
  const [pasteJson, setPasteJson] = useState('');
  const [copiedSnippet, setCopiedSnippet] = useState(false);
  const [modalFile, setModalFile] = useState<File | null>(null);

  useEffect(() => {
    if (!webFormFields.length) return;

    // 1. Start with ALL webForm fields (so none are missing)
    const mappings: FieldMapping[] = webFormFields
      .filter(wf => wf.key_name !== 'lead_id')   // ← don't show lead_id row, it's auto-generated
      .sort((a, b) => a.order_id - b.order_id)
      .map(wf => {
        const matchedSource = detectedFields.find(sf => {
          const n = (s: string) => s.toLowerCase().replace(/[_\s\-\.]/g, '');
          return (
            n(sf) === n(wf.key_name) ||
            n(sf) === n(wf.alias_name) ||
            n(sf).includes(n(wf.alias_name)) ||
            n(wf.alias_name).includes(n(sf))
          );
        });
        return {
          sourceField: matchedSource ?? '',
          targetField: wf.key_name,
          targetAlias: wf.alias_name,
          sampleValue: matchedSource ? (sampleRows[0]?.[matchedSource] ?? '') : '',
          isRequired: wf.is_required,
        };
      });


    // 2. Append any SOURCE fields that didn't match any webForm field (extras)
    const alreadyMappedSources = new Set(mappings.map(m => m.sourceField).filter(Boolean));
    const unmatchedSources = detectedFields.filter(sf => !alreadyMappedSources.has(sf));
    unmatchedSources.forEach(sf => {
      mappings.push({
        sourceField: sf,
        targetField: '',        // no webForm match — user must choose or skip
        targetAlias: '',
        sampleValue: sampleRows[0]?.[sf] ?? '',
      });
    });

    setFieldMappings(mappings);
  }, [detectedFields, webFormFields]);

  // Auto-build field mappings when source fields or webForm changes
  // useEffect(() => {
  //   if (!detectedFields.length) return;
  //   const mappings: FieldMapping[] = detectedFields.map(sf => {
  //     const matched = autoMatch(sf, webFormFields);
  //     return {
  //       sourceField: sf,
  //       targetField: matched?.key_name ?? '',
  //       targetAlias: matched?.alias_name ?? '',
  //       sampleValue: sampleRows[0]?.[sf] ?? '',
  //     };
  //   });
  //   setFieldMappings(mappings);
  // }, [detectedFields, webFormFields]);

  // ── Excel parser (read-excel-file) ──────────────────────────────────────
  const parseExcel = async (file: File) => {
    setIsParsing(true);
    setParseError(null);
    try {
      const rows = await readXlsxFile(file);
      if (!rows || rows.length < 2) {
        setParseError('File is empty or has no data rows.');
        return;
      }
      const headers = rows[0].map((cell) => String(cell ?? ''));

      const contactIdx = headers.findIndex(h =>
        h.toLowerCase().includes('contact') || h.toLowerCase().includes('phone') || h.toLowerCase().includes('mobile')
      );

      const samples: Record<string, string>[] = rows.slice(1, 4).map((row) =>
        Object.fromEntries(headers.map((h, i) => {
          let val = String(row[i] ?? '');
          // Contact field: agar 10 digit hai toh 91 lagao
          if (i === contactIdx && /^\d{10}$/.test(val.trim())) {
            val = '91' + val.trim();
          }
          return [h, val];
        }))
      );

      setDetectedFields(headers);
      setSampleRows(samples);
    } catch {
      setParseError('Could not parse file. Please check the format.');
    } finally {
      setIsParsing(false);
    }
  };

  // ── JSON / API / Website / Social parser ──────────────────────────────────
  const parseJson = (jsonStr: string) => {
    if (!jsonStr.trim()) return;
    try {
      const parsed = JSON.parse(jsonStr);
      let records: Record<string, any>[] = [];
      if (Array.isArray(parsed)) records = parsed;
      else if (Array.isArray(parsed?.data)) records = parsed.data;
      else if (Array.isArray(parsed?.leads)) records = parsed.leads;
      else if (Array.isArray(parsed?.results)) records = parsed.results;
      else records = [parsed];

      const flattened = records.slice(0, 5).map(r => flattenObject(r));
      const allKeys = Array.from(new Set(flattened.flatMap(r => Object.keys(r))));
      setDetectedFields(allKeys);
      setSampleRows(flattened.slice(0, 3));
      setParseError(null);
    } catch { setParseError('Invalid JSON.'); }
  };

  // ── Existing Excel upload (main page) ─────────────────────────────────────
  const inferDocType = (mime: string): 'image' | 'video' | 'audio' | 'file' | null => {
    if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
    if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
    if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
    if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
    return null;
  };
  const bytesToMB = (b: number) => (b / 1048576).toFixed(2);

const validateMappingValue = (
  targetField: string,
  sampleValue: string,
  webFormFields: WebFormField[],
): string | null => {
  if (targetField === 'lead_id') return null;
  const wf = webFormFields.find(f => f.key_name === targetField);
  if (!wf) return null;
  if (wf.key_name === 'contact_details' || wf.alias_name?.toLowerCase().includes('contact')) {
    if (sampleValue && !/^\d{12}$/.test(sampleValue.trim())) {
      return 'Must be exactly 12 digits';
    }
  }
  return null;
};

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const ext = file.name.toLowerCase().split('.').pop();
    if (BLOCKED_EXTENSIONS.has(ext)) { showSnackBar(`"${ext}" not allowed.`, 'error'); e.target.value = ''; return; }
    const tg = inferDocType(file.type);
    if (!tg) { showSnackBar('Unsupported file type.', 'error'); e.target.value = ''; return; }
    if (file.size > WHATSAPP_LIMITS[tg]) { showSnackBar(`File too large. Max ${bytesToMB(WHATSAPP_LIMITS[tg])} MB.`, 'error'); e.target.value = ''; return; }
    if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      setSelectedFile(file); setError(null);
    } else { setError('Please upload a valid .xlsx file.'); }
  };

  const handleFileUpload = async () => {
    if (!selectedFile) { setError('Please select a file.'); return; }
    if (!leadFormId) { setError('Lead Form ID missing.'); return; }
    const fd = new FormData(); fd.append('file', selectedFile);
    setLoading(true);
    try {
      const res = await actions.uploadLeadsFile(leadFormId, fd);
      const ec = res?.data?.data?.general_error?.error_cells ?? null;
      if (ec) setErrorCells(ec);
      if (res?.status === 200) navigate(`/r/records/v1`);
      else setError(res?.data?.data?.general_error?.message ?? 'Upload failed.');
    } catch { setError('Upload error.'); } finally { setLoading(false); }
  };

  const handleDownloadSample = () => {
    if (!leadFormId) { setError('Lead Form ID missing.'); return; }
    actions.downloadSampleLeadUploadFile(leadFormId);
  };

  const handleDownloadErrorFile = async () => {
    if (!selectedFile || !errorCells) { showSnackBar('No error data.', 'error'); return; }
    try {
      const fd = new FormData();
      fd.append('file', selectedFile); fd.append('error_cells', JSON.stringify(errorCells));
      await actions.downloadHighlightedErrorFile(fd);
      showSnackBar('Downloaded!', 'success');
    } catch { showSnackBar('Download failed.', 'error'); }
  };

  // ── Modal helpers ─────────────────────────────────────────────────────────
  const openModal = () => {
    setModalOpen(true); setActiveStep(0); setSelectedSource(null);
    setDetectedFields([]); setSampleRows([]); setFieldMappings([]);
    setModalFile(null); setPasteJson(''); setParseError(null);
    setTracking({ sourceName: '', sourceCampaignName: '', sourceCampaignId: '', sourceAdName: '', sourceAdId: '' });
  };
  const closeModal = () => setModalOpen(false);
  const handleNext = () => setActiveStep(s => Math.min(s + 1, STEPS.length - 1));
  const handleBack = () => setActiveStep(s => Math.max(s - 1, 0));

  const updateTargetField = (idx: number, targetField: string) => {
    const wf = webFormFields.find(f => f.key_name === targetField);
    setFieldMappings(prev => prev.map((m, i) =>
      i === idx ? { ...m, targetField, targetAlias: wf?.alias_name ?? '' } : m
    ));
  };
  const updateSourceField = (idx: number, val: string) =>
    setFieldMappings(prev => prev.map((m, i) => i === idx ? { ...m, sourceField: val } : m));
  const removeMapping = (idx: number) => setFieldMappings(prev => prev.filter((_, i) => i !== idx));
  const addMapping = () => setFieldMappings(prev => [...prev, { sourceField: '', targetField: '', targetAlias: '' }]);
  const autoMapAll = () => setFieldMappings(prev => prev.map(m => {
    const matched = autoMatch(m.sourceField, webFormFields);
    return matched ? { ...m, targetField: matched.key_name, targetAlias: matched.alias_name } : m;
  }));

  const webhookSnippet = `POST https://api.yourplatform.com/v1/leads/webhook\nContent-Type: application/json\nX-API-Key: YOUR_KEY\n\n{\n  "source": "${tracking.sourceName || 'source-name'}",\n  "campaign_id": "${tracking.sourceCampaignId || 'campaign-id'}",\n  "leads": [{ "email": "...", "phone": "..." }]\n}`;

  const handleFinalImport = async () => {
    if (!leadFormId) {
      showSnackBar('Lead Form ID missing.', 'error');
      return;
    }

    setLoading(true);
    try {
      if (selectedSource === 'excel') {
        if (!modalFile) {
          showSnackBar('No file selected.', 'error');
          setLoading(false);
          return;
        }

        // ✅ Exact same FormData as the original commented upload — only 'file' key
        const fd = new FormData();
        fd.append('file', modalFile);   // ← nothing else, same as original

        const res = await actions.uploadLeadsFile(leadFormId, fd);
        const ec = res?.data?.data?.general_error?.error_cells ?? null;
        if (ec) setErrorCells(ec);

        if (res?.status === 200) {
          showSnackBar('Records imported successfully!', 'success');
          closeModal();
          navigate(`/r/records/v1`);
        } else {
          showSnackBar(
            res?.data?.data?.general_error?.message ?? 'Upload failed. Please try again.',
            'error'
          );
        }

      } else {
        // Other sources — future
        const payload = {
          source: selectedSource,
          fieldMappings: fieldMappings.filter(m => m.sourceField && m.targetField),
          tracking,
          ...(selectedSource === 'website' && { websiteConfig }),
          ...(selectedSource === 'social_media' && { socialConfig }),
          ...(selectedSource === 'api' && { apiConfig }),
        };
        console.log('Import payload:', payload);
        showSnackBar('Import configured! (non-Excel sources coming soon)', 'success');
        closeModal();
      }

    } catch (err) {
      showSnackBar('Import failed. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };


  // ── Reusable target field dropdown using webForm fields ───────────────────
  const TargetSelect = ({ value, onChange }: { value: string; onChange: (v: string) => void }) => (
    <FormControl size="small" fullWidth>
      <InputLabel>→ Form Field</InputLabel>
      <Select value={value} label="→ Form Field" onChange={e => onChange(e.target.value)}>
        <MenuItem value=""><em>— Skip / Ignore —</em></MenuItem>
        {webFormFields
          .sort((a, b) => a.order_id - b.order_id)
          .map(f => (
            <MenuItem key={f.key_name} value={f.key_name}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                <Typography variant="body2" sx={{ flex: 1 }}>{f.alias_name}</Typography>
                <Chip label={f.key_type} size="small" variant="outlined"
                  sx={{ fontSize: '0.62rem', height: 16 }} />
                {f.is_required && (
                  <Chip label="req" size="small" color="error"
                    sx={{ fontSize: '0.62rem', height: 16 }} />
                )}
              </Box>
            </MenuItem>
          ))}
      </Select>
      {webFormFields.length === 0 && (
        <FormHelperText error>
          No fields found — set "leadWebFormData" in localStorage
        </FormHelperText>
      )}
    </FormControl>
  );

  // ── Detected fields + preview panel (reused across sources) ──────────────
  const DetectedFieldsPreview = () => {
    if (parseError) return <Alert severity="error">{parseError}</Alert>;
    if (!detectedFields.length) return null;
    return (
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="subtitle2" fontWeight={700} gutterBottom>
          ✅ Detected Fields ({detectedFields.length})
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: sampleRows.length ? 1.5 : 0 }}>
          {detectedFields.map(f => (
            <Chip key={f} label={f} size="small" variant="outlined"
              sx={{ fontFamily: 'monospace', fontSize: '0.72rem' }} />
          ))}
        </Box>
        {sampleRows.length > 0 && (
          <>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
              Sample data ({sampleRows.length} rows):
            </Typography>
            <TableContainer sx={{ maxHeight: 130 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ '& th': { backgroundColor: '#f5f5f5', fontWeight: 700, fontSize: '0.78rem' } }}>
                    <TableCell sx={{ width: '35%' }}>Form Field (webForm)</TableCell>
                    <TableCell sx={{ width: '8%', textAlign: 'center' }}>Status</TableCell>
                    <TableCell sx={{ width: '32%' }}>← Source Field (from data)</TableCell>
                    <TableCell sx={{ width: '20%' }}>Sample Value</TableCell>
                    <TableCell sx={{ width: '5%' }} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fieldMappings.map((m, idx) => {
                    const isWebFormRow = !!m.targetField;
                    const isMapped = isWebFormRow && !!m.sourceField;
                    const isRequired = m.isRequired;

                    return (
                      <TableRow key={idx} sx={{
                        backgroundColor: isMapped
                          ? 'rgba(46,125,50,0.04)'
                          : isRequired
                            ? 'rgba(211,47,47,0.04)'   // red tint for unmapped required fields
                            : 'rgba(255,152,0,0.03)',
                      }}>
                        {/* LEFT: webForm field (fixed, not editable) */}
                        <TableCell>
                          {isWebFormRow ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <Chip
                                label={m.targetAlias || m.targetField}
                                size="small"
                                color={isMapped ? 'primary' : isRequired ? 'error' : 'default'}
                                variant={isMapped ? 'filled' : 'outlined'}
                                sx={{ fontFamily: 'monospace', fontSize: '0.72rem', maxWidth: 180 }}
                              />
                              {isRequired && !isMapped && (
                                <Chip label="required" size="small" color="error"
                                  sx={{ fontSize: '0.6rem', height: 16 }} />
                              )}
                            </Box>
                          ) : (
                            // Extra source-only row — show a "no form field" placeholder
                            <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>
                              — no form field —
                            </Typography>
                          )}
                        </TableCell>

                        {/* STATUS */}
                        <TableCell align="center">
                          {isMapped
                            ? <CheckCircleIcon sx={{ color: 'success.main', fontSize: 18 }} />
                            : isRequired
                              ? <WarningAmberIcon sx={{ color: 'error.main', fontSize: 18 }} />
                              : <SwapHorizIcon sx={{ color: 'warning.main', fontSize: 18 }} />}
                        </TableCell>

                        {/* RIGHT: source field (editable dropdown or text) */}
                        <TableCell>
                          <FormControl size="small" fullWidth>
                            <Select
                              value={m.sourceField}
                              displayEmpty
                              onChange={e => {
                                const sf = e.target.value;
                                setFieldMappings(prev => prev.map((row, i) =>
                                  i === idx ? { ...row, sourceField: sf, sampleValue: sampleRows[0]?.[sf] ?? '' } : row
                                ));
                              }}
                              renderValue={v => v || <em style={{ color: '#999' }}>— not mapped —</em>}
                              sx={{ fontSize: '0.78rem' }}
                            >
                              <MenuItem value=""><em>— skip / not mapped —</em></MenuItem>
                              {detectedFields.map(sf => (
                                <MenuItem key={sf} value={sf}
                                  disabled={
                                    // Disable if already used in another row (prevent duplicate source mapping)
                                    fieldMappings.some((r, i) => i !== idx && r.sourceField === sf)
                                  }
                                >
                                  <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.78rem' }}>
                                    {sf}
                                  </Typography>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>

                        {/* SAMPLE VALUE */}
                        <TableCell>
                          <Typography variant="caption" color="text.secondary"
                            title={m.sampleValue}
                            sx={{
                              fontFamily: 'monospace', display: 'block',
                              maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                            }}>
                            {m.sampleValue || (m.sourceField && sampleRows[0]?.[m.sourceField]) || '—'}
                          </Typography>
                        </TableCell>

                        {/* DELETE — only for extra source rows (non-webForm rows) */}
                        <TableCell>
                          {!isWebFormRow && (
                            <IconButton size="small" onClick={() => removeMapping(idx)}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

              </Table>
            </TableContainer>
          </>
        )}
      </Paper>
    );
  };

  // ── Step renderers ────────────────────────────────────────────────────────

  const renderStep0 = () => (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Choose your lead source — fields are detected automatically from your data.
      </Typography>
      <Grid container spacing={2}>
        {(Object.keys(SOURCE_META) as ImportSource[]).map(src => {
          const meta = SOURCE_META[src];
          const sel = selectedSource === src;
          return (
            <Grid item xs={12} sm={6} key={src}>
              <Paper variant="outlined" onClick={() => setSelectedSource(src)} sx={{
                p: 2, cursor: 'pointer', position: 'relative',
                borderColor: sel ? meta.color : 'divider',
                borderWidth: sel ? 2 : 1,
                backgroundColor: sel ? `${meta.color}12` : 'transparent',
                transition: 'all 0.15s',
                '&:hover': { borderColor: meta.color, backgroundColor: `${meta.color}08` },
              }}>
                {sel && <CheckCircleIcon sx={{ position: 'absolute', top: 8, right: 8, color: meta.color, fontSize: 18 }} />}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
                  <Box sx={{ color: meta.color }}>{meta.icon}</Box>
                  <Typography variant="subtitle2" fontWeight={600}>{meta.label}</Typography>
                </Box>
                <Typography variant="caption" color="text.secondary">{meta.description}</Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );

  const renderStep1 = () => {
    if (!selectedSource) return null;

    // ── EXCEL ──────────────────────────────────────────────────────────────
    if (selectedSource === 'excel') return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Alert severity="info" icon={<InfoOutlinedIcon />}>
          Upload your .xlsx — all column headers are detected automatically and shown below.
        </Alert>
        <Box
          sx={{
            border: `2px dashed ${modalFile ? '#2e7d32' : '#1976d2'}`,
            p: 3, borderRadius: 2, display: 'flex', flexDirection: 'column',
            alignItems: 'center', gap: 1, cursor: 'pointer',
            backgroundColor: modalFile ? 'rgba(46,125,50,0.05)' : 'transparent',
            '&:hover': { backgroundColor: '#e3f2fd' },
          }}
          onClick={() => document.getElementById('modal-xlsx')?.click()}>
          <CloudUploadIcon sx={{ fontSize: 40, color: modalFile ? '#2e7d32' : '#1976d2' }} />
          <Typography variant="body2" color="text.secondary">
            {modalFile ? 'Click to change file' : 'Click or drag to upload .xlsx'}
          </Typography>
          <input type="file" id="modal-xlsx" accept=".xlsx" style={{ display: 'none' }}
            onChange={e => {
              const f = e.target.files?.[0];
              if (f) { setModalFile(f); parseExcel(f); }
            }} />
          {modalFile && <Chip icon={<CheckCircleIcon />} label={modalFile.name} color="success" size="small" />}
        </Box>
        {isParsing && <LinearProgress />}
        <DetectedFieldsPreview />
      </Box>
    );

    // ── JSON paste panel (shared by website / social / api) ───────────────
    const jsonPastePlaceholders: Record<ImportSource, string> = {
      website: '{\n  "name": "John Doe",\n  "email": "john@example.com",\n  "phone": "+91..."\n}',
      social_media: '{\n  "field_data": [\n    {"name": "full_name", "values": ["John"]},\n    {"name": "email", "values": ["j@e.com"]}\n  ]\n}',
      api: '[\n  {\n    "id": 1,\n    "name": "Jane",\n    "email": "jane@co.com",\n    "phone": "9999999999"\n  }\n]',
      excel: '',
    };

    const PastePanel = () => (
      <>
        <Divider><Typography variant="caption">Paste Sample Data → Auto-Detect Fields</Typography></Divider>
        <TextField multiline minRows={4} maxRows={8} fullWidth size="small"
          label="Paste a sample JSON object / array from this source"
          value={pasteJson}
          placeholder={jsonPastePlaceholders[selectedSource]}
          onChange={e => { setPasteJson(e.target.value); parseJson(e.target.value); }} />
        <DetectedFieldsPreview />
      </>
    );

    // ── WEBSITE ────────────────────────────────────────────────────────────
    if (selectedSource === 'website') return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Alert severity="info">Connect your website, then paste a sample lead payload to detect fields.</Alert>
        <TextField label="Website URL" fullWidth size="small" value={websiteConfig.url}
          onChange={e => setWebsiteConfig(p => ({ ...p, url: e.target.value }))}
          placeholder="https://yourwebsite.com" />
        <TextField label="Form CSS Selector (optional)" fullWidth size="small" value={websiteConfig.formSelector}
          onChange={e => setWebsiteConfig(p => ({ ...p, formSelector: e.target.value }))}
          placeholder="#contact-form" />
        <TextField label="Embed API Key" fullWidth size="small" value={websiteConfig.apiKey}
          onChange={e => setWebsiteConfig(p => ({ ...p, apiKey: e.target.value }))} />
        <PastePanel />
      </Box>
    );

    // ── SOCIAL MEDIA ───────────────────────────────────────────────────────
    if (selectedSource === 'social_media') return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Alert severity="info">Connect your ad account, then paste a sample lead from your platform API.</Alert>
        <FormControl fullWidth size="small">
          <InputLabel>Platform</InputLabel>
          <Select value={socialConfig.platform} label="Platform"
            onChange={e => setSocialConfig(p => ({ ...p, platform: e.target.value as any }))}>
            {SOCIAL_PLATFORMS.map(p => <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>)}
          </Select>
        </FormControl>
        <TextField label="Access Token" fullWidth size="small" type="password"
          value={socialConfig.accessToken}
          onChange={e => setSocialConfig(p => ({ ...p, accessToken: e.target.value }))} />
        <TextField label="Ad Account ID" fullWidth size="small"
          value={socialConfig.adAccountId}
          onChange={e => setSocialConfig(p => ({ ...p, adAccountId: e.target.value }))}
          placeholder="act_XXXXXXXXXX" />
        <TextField label="Lead Form ID" fullWidth size="small"
          value={socialConfig.formId}
          onChange={e => setSocialConfig(p => ({ ...p, formId: e.target.value }))} />
        <PastePanel />
      </Box>
    );

    // ── API ────────────────────────────────────────────────────────────────
    if (selectedSource === 'api') return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Alert severity="info">Configure your API, then paste a sample response to detect all fields.</Alert>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <TextField label="Endpoint URL" fullWidth size="small"
              value={apiConfig.endpointUrl}
              onChange={e => setApiConfig(p => ({ ...p, endpointUrl: e.target.value }))}
              placeholder="https://api.example.com/leads" />
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Method</InputLabel>
              <Select value={apiConfig.method} label="Method"
                onChange={e => setApiConfig(p => ({ ...p, method: e.target.value as any }))}>
                <MenuItem value="GET">GET</MenuItem>
                <MenuItem value="POST">POST</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <FormControl fullWidth size="small">
          <InputLabel>Auth Type</InputLabel>
          <Select value={apiConfig.authType} label="Auth Type"
            onChange={e => setApiConfig(p => ({ ...p, authType: e.target.value as any }))}>
            <MenuItem value="none">No Auth</MenuItem>
            <MenuItem value="bearer">Bearer Token</MenuItem>
            <MenuItem value="api_key">API Key Header</MenuItem>
            <MenuItem value="basic">Basic Auth</MenuItem>
          </Select>
        </FormControl>
        {apiConfig.authType !== 'none' && (
          <TextField label="Auth Value" fullWidth size="small" type="password"
            value={apiConfig.authValue}
            onChange={e => setApiConfig(p => ({ ...p, authValue: e.target.value }))} />
        )}
        <PastePanel />
        <Divider><Typography variant="caption">OR receive via Webhook</Typography></Divider>
        <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#fafafa', position: 'relative' }}>
          <Typography variant="caption" fontWeight={700} display="block" mb={1}>
            POST leads to this endpoint:
          </Typography>
          <Typography variant="caption" component="pre"
            sx={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '0.7rem' }}>
            {webhookSnippet}
          </Typography>
          <Tooltip title={copiedSnippet ? 'Copied!' : 'Copy'}>
            <IconButton size="small" onClick={() => {
              navigator.clipboard.writeText(webhookSnippet);
              setCopiedSnippet(true); setTimeout(() => setCopiedSnippet(false), 2000);
            }} sx={{ position: 'absolute', top: 8, right: 8 }}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Paper>
      </Box>
    );

    return null;
  };

  // ── Step 2: Field Mapping Table ────────────────────────────────────────────
  const renderStep2 = () => {
    const mapped = fieldMappings.filter(m => m.targetField && m.sourceField).length;
    const unmapped = fieldMappings.filter(m => m.targetField && !m.sourceField).length;
    const reqMissing = fieldMappings.filter(m => m.isRequired && !m.sourceField).length;
    const extras = fieldMappings.filter(m => !m.targetField && m.sourceField).length;

    // Split: webForm rows first, then unmatched source extras
    const webFormRows = fieldMappings.filter(m => !!m.targetField);
    const extraRows = fieldMappings.filter(m => !m.targetField);
    const orderedMappings = [...webFormRows, ...extraRows];

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

        {/* Summary bar */}
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Chip icon={<CheckCircleIcon />} label={`${mapped} mapped`} color="success" size="small" />
          <Chip icon={<WarningAmberIcon />} label={`${unmapped} not mapped`} color="warning" size="small" />
          {reqMissing > 0 && (
            <Chip icon={<WarningAmberIcon />} label={`${reqMissing} required missing — must map to proceed`} color="error" size="small" />
          )}
          {extras > 0 && (
            <Chip label={`${extras} extra source fields`} color="default" size="small" />
          )}
          <Button size="small" variant="outlined" startIcon={<AutoFixHighIcon />}
            onClick={autoMapAll} sx={{ ml: 'auto', textTransform: 'none' }}>
            Auto-Map All
          </Button>
          <Button size="small" variant="outlined" startIcon={<AddIcon />}
            onClick={addMapping} sx={{ textTransform: 'none' }}>
            Add Row
          </Button>
        </Box>

        {/* Required missing warning banner */}
        {reqMissing > 0 && (
          <Alert severity="error" icon={<WarningAmberIcon />}>
            <strong>{reqMissing} required field{reqMissing > 1 ? 's are' : ' is'} not mapped.</strong>
            {' '}Please select a source column for all required fields before proceeding.
          </Alert>
        )}

        {/* Mapping table */}
        <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 340, overflow: 'auto' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow sx={{ '& th': { backgroundColor: '#f5f5f5', fontWeight: 700, fontSize: '0.78rem' } }}>
                <TableCell sx={{ width: '30%' }}>Form Field (webForm)</TableCell>
                <TableCell sx={{ width: '8%', textAlign: 'center' }}>Status</TableCell>
                <TableCell sx={{ width: '32%' }}>← Source Column (from file)</TableCell>
                <TableCell sx={{ width: '22%' }}>Sample Value</TableCell>
                <TableCell sx={{ width: '8%' }} />
              </TableRow>
            </TableHead>
            <TableBody>
              {orderedMappings.map((m) => {
                // find actual index in fieldMappings for state updates
                const idx = fieldMappings.indexOf(m);
                const isWebFormRow = !!m.targetField;
                const isMapped = isWebFormRow && !!m.sourceField;
                const isRequired = m.isRequired;
                const sampleVal = m.sampleValue || sampleRows[0]?.[m.sourceField] || '';
                const validationErr = isMapped
                  ? validateMappingValue(m.targetField, sampleVal, webFormFields)
                  : null;

                return (
                  <TableRow key={idx} sx={{
                    backgroundColor: validationErr
                      ? 'rgba(211,47,47,0.06)'
                      : isMapped
                        ? 'rgba(46,125,50,0.04)'
                        : isRequired
                          ? 'rgba(211,47,47,0.04)'
                          : 'rgba(255,152,0,0.03)',
                  }}>

                    {/* LEFT: webForm field label (fixed) */}
                    <TableCell>
                      {isWebFormRow ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                          <Chip
                            label={m.targetAlias || m.targetField}
                            size="small"
                            color={validationErr ? 'error' : isMapped ? 'primary' : isRequired ? 'error' : 'default'}
                            variant={isMapped && !validationErr ? 'filled' : 'outlined'}
                            sx={{ fontFamily: 'monospace', fontSize: '0.72rem', maxWidth: 160 }}
                          />
                          {isRequired && (
                            <Chip
                              label="required"
                              size="small"
                              color="error"
                              variant={isMapped ? 'outlined' : 'filled'}
                              sx={{ fontSize: '0.6rem', height: 16 }}
                            />
                          )}
                        </Box>
                      ) : (
                        <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>
                          — no form field —
                        </Typography>
                      )}
                    </TableCell>

                    {/* STATUS icon */}
                    <TableCell align="center">
                      {validationErr
                        ? <WarningAmberIcon sx={{ color: 'error.main', fontSize: 18 }} />
                        : isMapped
                          ? <CheckCircleIcon sx={{ color: 'success.main', fontSize: 18 }} />
                          : isRequired
                            ? <WarningAmberIcon sx={{ color: 'error.main', fontSize: 18 }} />
                            : <SwapHorizIcon sx={{ color: 'warning.main', fontSize: 18 }} />}
                    </TableCell>

                    {/* SOURCE column dropdown */}
                    <TableCell>
                      <FormControl
                        size="small"
                        fullWidth
                        error={isRequired && !m.sourceField}
                      >
                        <Select
                          value={m.sourceField}
                          displayEmpty
                          onChange={e => {
                            const sf = e.target.value;
                            setFieldMappings(prev => prev.map((row, i) =>
                              i === idx
                                ? { ...row, sourceField: sf, sampleValue: sampleRows[0]?.[sf] ?? '' }
                                : row
                            ));
                          }}
                          renderValue={v => v
                            ? <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.78rem' }}>{v}</Typography>
                            : <em style={{ color: isRequired ? '#d32f2f' : '#999', fontSize: '0.78rem' }}>
                              {isRequired ? '⚠ Required — select a column' : '— not mapped —'}
                            </em>
                          }
                          sx={{
                            fontSize: '0.78rem',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: isRequired && !m.sourceField ? '#d32f2f' : undefined,
                            },
                          }}
                        >
                          <MenuItem value=""><em>— skip / not mapped —</em></MenuItem>
                          {detectedFields.map(sf => (
                            <MenuItem
                              key={sf}
                              value={sf}
                              disabled={fieldMappings.some((r, i) => i !== idx && r.sourceField === sf)}
                            >
                              <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.78rem' }}>
                                {sf}
                              </Typography>
                            </MenuItem>
                          ))}
                        </Select>
                        {isRequired && !m.sourceField && (
                          <FormHelperText error sx={{ fontSize: '0.65rem', mx: 0 }}>
                            This field is required
                          </FormHelperText>
                        )}
                      </FormControl>
                    </TableCell>

                    {/* SAMPLE VALUE + inline validation error */}
                    <TableCell>
                      <Typography
                        variant="caption"
                        color={validationErr ? 'error' : 'text.secondary'}
                        title={sampleVal}
                        sx={{
                          fontFamily: 'monospace', display: 'block',
                          maxWidth: 140, overflow: 'hidden',
                          textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        }}
                      >
                        {sampleVal || '—'}
                      </Typography>
                      {validationErr && (
                        <Typography variant="caption" color="error" sx={{ fontSize: '0.65rem', display: 'block' }}>
                          {validationErr}
                        </Typography>
                      )}
                    </TableCell>

                    {/* DELETE — only for extra unmatched source rows */}
                    <TableCell>
                      {!isWebFormRow && (
                        <IconButton size="small" onClick={() => removeMapping(idx)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}

              {orderedMappings.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                      No fields detected. Go back and upload your file.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Divider />

        {/* Ad tracking fields — unchanged */}
        <Box sx={{ backgroundColor: '#fff8e1', border: '1px solid #ffc107', borderRadius: 1, p: 2 }}>
          <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5, color: '#e65100' }}>
            📊 Ad Performance Tracking
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
            Stored on every imported lead for attribution & performance reporting.
          </Typography>
          <Grid container spacing={1.5}>
            {([
              ['sourceName', 'Source Name', 'e.g. Facebook'],
              ['sourceCampaignName', 'Campaign Name', 'e.g. Summer Sale 2025'],
              ['sourceCampaignId', 'Campaign ID', 'e.g. 120212345678'],
              ['sourceAdName', 'Ad Name', 'e.g. Banner – Variant A'],
              ['sourceAdId', 'Ad ID', 'e.g. 987654321'],
            ] as [keyof TrackingFields, string, string][]).map(([key, label, ph]) => (
              <Grid item xs={12} sm={6} key={key}>
                <TextField label={label} fullWidth size="small" placeholder={ph}
                  value={tracking[key]}
                  onChange={e => setTracking(p => ({ ...p, [key]: e.target.value }))} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    );
  };


  // ── Step 3: Review ─────────────────────────────────────────────────────────
  const renderStep3 = () => {
    const mapped = fieldMappings.filter(m => m.sourceField && m.targetField);
    const unmapped = fieldMappings.filter(m => m.sourceField && !m.targetField);
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Alert severity={unmapped.length > 0 ? 'warning' : 'success'}
          icon={unmapped.length > 0 ? <WarningAmberIcon /> : <CheckCircleIcon />}>
          {unmapped.length > 0
            ? `${unmapped.length} field(s) unmapped and will be skipped.`
            : 'All fields mapped — ready to import!'}
        </Alert>

        {/* Source */}
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle2" fontWeight={700} gutterBottom>Source</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ color: SOURCE_META[selectedSource!].color }}>{SOURCE_META[selectedSource!].icon}</Box>
            <Typography variant="body2">{SOURCE_META[selectedSource!].label}</Typography>
          </Box>
        </Paper>

        {/* Mapping summary */}
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle2" fontWeight={700} gutterBottom>
            Field Mappings — {mapped.length} active, {unmapped.length} skipped
          </Typography>
          <TableContainer sx={{ maxHeight: 200 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ '& th': { backgroundColor: '#f5f5f5', fontWeight: 700 } }}>
                  <TableCell>Source Field</TableCell>
                  <TableCell>Sample</TableCell>
                  <TableCell align="center">→</TableCell>
                  <TableCell>Form Field</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fieldMappings.map((m, i) => (
                  <TableRow key={i} sx={{ opacity: m.targetField ? 1 : 0.4 }}>
                    <TableCell>
                      <Chip label={m.sourceField} size="small" variant="outlined"
                        sx={{ fontFamily: 'monospace', fontSize: '0.7rem' }} />
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" color="text.secondary"
                        sx={{ fontFamily: 'monospace' }}>
                        {m.sampleValue || sampleRows[0]?.[m.sourceField] || '—'}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      {m.targetField
                        ? <CheckCircleIcon sx={{ color: 'success.main', fontSize: 16 }} />
                        : <CloseIcon sx={{ color: 'error.main', fontSize: 16 }} />}
                    </TableCell>
                    <TableCell>
                      {m.targetField
                        ? <Chip label={m.targetAlias || m.targetField} size="small" color="primary" />
                        : <Typography variant="caption" color="text.disabled">skipped</Typography>}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Tracking summary */}
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle2" fontWeight={700} gutterBottom>📊 Ad Tracking</Typography>
          <Grid container spacing={1}>
            {Object.entries(tracking).filter(([, v]) => v).map(([k, v]) => (
              <Grid item xs={6} key={k}>
                <Typography variant="caption" color="text.secondary" display="block">
                  {k.replace(/([A-Z])/g, ' $1').trim()}
                </Typography>
                <Typography variant="body2" fontWeight={500}>{v}</Typography>
              </Grid>
            ))}
          </Grid>
          {!Object.values(tracking).some(Boolean) && (
            <Typography variant="body2" color="text.secondary">No tracking fields set.</Typography>
          )}
        </Paper>
      </Box>
    );
  };

  const stepContent = [renderStep0, renderStep1, renderStep2, renderStep3];

  const canProceed = () => {
    if (activeStep === 0) return !!selectedSource;
    if (activeStep === 1) {
      if (selectedSource === 'excel') return detectedFields.length > 0;
      if (selectedSource === 'website') return !!websiteConfig.url;
      if (selectedSource === 'social_media') return !!socialConfig.platform && !!socialConfig.accessToken;
      return true;
    }
    if (activeStep === 2) {
      const requiredUnmapped = fieldMappings.filter(
        m => m.isRequired && !m.sourceField && m.targetField !== 'lead_id'  // ← skip lead_id
      );
      return requiredUnmapped.length === 0;
    }

    if (activeStep === 3) {
      return fieldMappings.some(m => m.sourceField && m.targetField);
    }
    return true;
  };



  // ── Main page ─────────────────────────────────────────────────────────────
  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', padding: '16px' }}>
      <Grid container spacing={2} justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Grid item>
          <Typography variant="h4" component="h1" fontWeight="bold">Import Records</Typography>
          <Typography variant="body2" color="text.secondary">
            Upload from Excel or connect any external lead source with dynamic field mapping
          </Typography>
        </Grid>
        <Grid item sx={{ display: 'flex', gap: 1 }}>
          <Button variant="contained" color="secondary" startIcon={<AddIcon />}
            onClick={openModal} sx={{ textTransform: 'none', fontWeight: 600 }}>
            Import from Other Sources
          </Button>
          <BackButton onClick={() => navigate(-1)} />
        </Grid>
      </Grid>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Button variant="outlined" color="secondary" onClick={handleDownloadSample}
          sx={{ width: 'fit-content' }}>
          Download Sample File
        </Button>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress /></Box>
        ) : (
          <Box sx={{
            border: '2px dashed #1976d2', p: 4,
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            cursor: 'pointer', borderRadius: 2, flexDirection: 'column', textAlign: 'center',
            '&:hover': { backgroundColor: '#e3f2fd' },
          }}
            onClick={() => document.getElementById('file-upload')?.click()}>
            <CloudUploadIcon sx={{ fontSize: 50, color: '#1976d2', mb: 2 }} />
            <input type="file" id="file-upload"
              accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={handleFileChange} style={{ display: 'none' }} />
            <Typography variant="body2" color="textSecondary">
              Drag & Drop or Click to Upload<br />
              <span style={{ fontSize: '0.9rem', color: '#616161' }}>Supports XLSX Only</span>
            </Typography>
            <FormHelperText>Allowed: .xlsx</FormHelperText>
          </Box>
        )}

        {selectedFile && (
          <Typography variant="body2">Selected: <strong>{selectedFile.name}</strong></Typography>
        )}

        {error && (
          <Box sx={{ p: 2, backgroundColor: '#ffebee', borderRadius: 1, border: '1px solid #ef5350' }}>
            <Typography variant="body2" color="error">{error}</Typography>
            {errorCells && (
              <Button variant="contained" color="error" size="small"
                startIcon={<DownloadIcon />} onClick={handleDownloadErrorFile}
                sx={{ textTransform: 'none', mt: 1 }}>
                Download Error File
              </Button>
            )}
          </Box>
        )}

        <Button variant="contained" color="primary" onClick={handleFileUpload}
          disabled={loading || !selectedFile} sx={{ textTransform: 'none', width: 'fit-content' }}>
          {loading ? 'Uploading...' : 'Upload Records'}
        </Button>
      </Box>

      {/* ── Multi-Source Wizard Modal ─────────────────────────────────────── */}
      <Dialog open={modalOpen} onClose={closeModal} maxWidth="md" fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
          <Box>
            <Typography variant="h6" fontWeight={700}>Import from External Source</Typography>
            {selectedSource && (
              <Chip
                icon={<Box sx={{ color: SOURCE_META[selectedSource].color, display: 'flex', alignItems: 'center' }}>
                  {SOURCE_META[selectedSource].icon}
                </Box>}
                label={SOURCE_META[selectedSource].label}
                size="small" sx={{ mt: 0.5 }} />
            )}
          </Box>
          <IconButton onClick={closeModal}><CloseIcon /></IconButton>
        </DialogTitle>

        <Divider />

        <Box sx={{ px: 3, pt: 2 }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {STEPS.map(label => <Step key={label}><StepLabel>{label}</StepLabel></Step>)}
          </Stepper>
        </Box>

        <DialogContent sx={{ px: 3, py: 2, minHeight: 360 }}>
          {stepContent[activeStep]?.()}
        </DialogContent>

        <Divider />

        <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
          <Button onClick={handleBack} disabled={activeStep === 0} variant="outlined">Back</Button>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button onClick={closeModal} variant="text" color="inherit">Cancel</Button>
            {activeStep < STEPS.length - 1 ? (
              <Button variant="contained" onClick={handleNext}
                disabled={!canProceed()} endIcon={<ArrowForwardIcon />}>
                Next
              </Button>
            ) : (
              <Button variant="contained" color="success" onClick={handleFinalImport}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <CheckCircleIcon />}>
                {loading ? 'Importing...' : 'Start Import'}
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ImportLeads;
